export const GET_PARTNERS_QUERY = `
  query GetPartners($where: partners_bool_exp = {}) {
    partners(where: $where, order_by: { created_at: desc }) {
      id
      partner_name
      partner_description
      partner_status
      company_id
      created_at
      updated_at
      company {
        id
        name
      }
    }
  }
`;

export const GET_PARTNER_BY_ID_QUERY = `
  query GetPartnerById($id: Int!) {
    partners_by_pk(id: $id) {
      id
      partner_name
      partner_description
      partner_status
      company_id
      created_at
      updated_at
      company {
        id
        name
      }
    }
  }
`; 